export default {
    namespaced: true,
    state: {
        currentProject: {},
        currentProjectId: '',
        works: [],
        activeWorkIndex: 0,
        sections: [],
    },
    mutations: {
        setActiveWorkIndex(state, payload) {
            state.activeWorkIndex = payload
        },
        setCurrentProject(state, payload) {
            state.currentProject = payload;
            state.currentProjectId = payload.id
        },
        setWorks(state, works) {
            state.works = works;
        },
        setSections(state, sections) {
            state.sections = sections;

        }
    },
    actions: {},
    getters: {
        cProject: state => state.currentProject,
        cProjectId: state => state.currentProjectId,
        works: state => state.works,
        activeWork: state => state.works[state.activeWorkIndex],
        activeWorkId: state => state.works[state.activeWorkIndex].id,
        sections: state => state.sections
    }
}